var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8719_41256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2559 16.9436C18.0732 16.9509 17.8933 16.8968 17.7449 16.7899C17.5965 16.6831 17.4882 16.5296 17.4371 16.3541C16.7493 13.9714 14.0309 11.9899 11.1488 11.6706V12.5876C11.1488 12.8808 11.0702 13.1686 10.921 13.4209C10.7719 13.6733 10.5577 13.8811 10.3009 14.0224C10.0441 14.1638 9.75402 14.2337 9.461 14.2247C9.16798 14.2157 8.88274 14.1282 8.63507 13.9714L2.08472 9.77914C1.84478 9.62649 1.64873 9.41398 1.51587 9.16253C1.38301 8.91109 1.31792 8.62939 1.32701 8.34515C1.3361 8.06091 1.41905 7.78393 1.5677 7.54149C1.71635 7.29905 1.92558 7.0995 2.17478 6.96249L8.72514 3.37617C8.97516 3.2318 9.25891 3.1561 9.54762 3.15674C9.83634 3.15738 10.1197 3.23434 10.3691 3.37981C10.6185 3.52529 10.825 3.73411 10.9677 3.98511C11.1103 4.2361 11.1841 4.52036 11.1815 4.80906V5.93081C15.2018 6.34021 19.3695 9.68907 19.3695 14.1187C19.3697 14.8893 19.2594 15.6558 19.0419 16.395C18.9852 16.5574 18.8787 16.6979 18.7376 16.7963C18.5965 16.8948 18.4279 16.9463 18.2559 16.9436ZM10.3627 9.98384C11.7644 9.9889 13.1485 10.2966 14.4204 10.8859C15.6922 11.4752 16.8218 12.3321 17.7319 13.3982C17.257 9.98384 13.6379 7.52746 10.3627 7.52746C10.1456 7.52746 9.9373 7.44119 9.78375 7.28764C9.6302 7.13408 9.54393 6.92582 9.54393 6.70866V4.80906L2.99358 8.40357L9.54393 12.5876V10.8026C9.54393 10.5855 9.6302 10.3772 9.78375 10.2237C9.9373 10.0701 10.1456 9.98384 10.3627 9.98384Z",
    fill: "#0ACD95",
    stroke: "#0ACD95",
    strokeWidth: 0.659673
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8719_41256"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.701172,
    width: 20,
    height: 20,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLead);
export default __webpack_public_path__ + "static/media/Lead.820e167aaaac5e0b468a68ebed0a5cfc.svg";
export { ForwardRef as ReactComponent };